module.exports = __webpack_public_path__ + "img/NazaninOsman-Sy7rbaziRangakan.bfc20a47.jpg";